// src/Models/projectEnvironmentModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class ProjectEnvironmentModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      environmentID: data.environmentId || data.environmentID,
      projectID: data.projectId || data.projectID,
      environmentName: data.environmentName,
      isDefaultFlag: data.isDefaultFlag !== undefined ? data.isDefaultFlag : false,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      environmentId: Number(data.environmentID || data.environmentId || 0),
      projectId: Number(data.projectID || data.projectId || 0),
      environmentName: data.environmentName || '',
      isDefaultFlag: data.isDefaultFlag === true || data.isDefaultFlag === 'true',
    };
  }
}
